export default __webpack_public_path__ + "static/media/NPC.68e656dd.png";